<template>
  <div>
    <h1>
      注册
    </h1>
  </div>
</template>

<script>
    export default {
        name: "AuthRegister"
    }
</script>

<style scoped>

</style>